import { Alert, Platform } from 'react-native';
import { check, request, PERMISSIONS, RESULTS, openSettings } from 'react-native-permissions';

export const requestCameraPermission = async (
  title: string,
  message: string,
  cancel: string,
  settings: string,
): Promise<boolean> => {
  const permission =
    Platform.OS === 'ios' ? PERMISSIONS.IOS.CAMERA : PERMISSIONS.ANDROID.CAMERA;

  const status = await check(permission);
  if (status === RESULTS.GRANTED) return true;

  if (status === RESULTS.BLOCKED || status === RESULTS.UNAVAILABLE) {
    Alert.alert(title, message, [
      { text: cancel, style: 'cancel' },
      { text: settings, onPress: () => openSettings() },
    ]);
    return false;
  }

  const result = await request(permission);
  return result === RESULTS.GRANTED;
};
